import "./styles.css"
import type { MainProps } from "@site-types/components/main"

export function Main({ children }: MainProps) {
  return <main className="main-content">{children}</main>
}

export default Main
